export const timestampToDate = (
  dateTimestamp?: number | null
): Date | undefined =>
  dateTimestamp ? new Date(dateTimestamp * 1000) : undefined;

export const timestampToString = (dateTimestamp?: number | null): string =>
  dateTimestamp ? new Date(dateTimestamp * 1000).toISOString().split("T")[0] : "-";
